/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
//import Footer from "components/Footer/Footer.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2022/07/tribalism-news-july-2022/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2022/07/tribalism-news-july-2022/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2022/07/tribalism-news-july-2022/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Tribalism News July 2022",
  date: "2022-07-20",
  summary: "We are an Australian Digital Marketing Agency based in Melbourne. This is a blog post on what we have been up to recently.",
  image: "/img/photo-gallery/mk-6.jpg",
  url: "https://www.tribalism.com.au/blog-post/2022/07/tribalism-news-july-2022",
  author: "Scott Sunderland"
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Tribalism News July 2022"
        image="/img/photo-gallery/mk-6.jpg"
        url="https://www.tribalism.com.au/blog-post/2022/07/tribalism-news-july-2022"
        type="article"
        description="We are an Australian Digital Marketing Agency based in Melbourne. This is an blog post on what we have been up to recently."
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/photo-gallery/mk-6.jpg" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Tribalism News July 2022
              </h1>
              <h4 className={classes.subtitle}>
               We are an Australian Digital Marketing Agency based in Melbourne. This is an blog post on what we have been up to recently.
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>
      <SectionSimilarStories />


      <Footer
       
      />
    </div>
  );
}
